<template>
  <p v-html="transform(this.str)" class="custom-p-label right-read"></p>
</template>

<script>
// 占位替换
const tempReg = /\{n\d{1,}\}/g
// 豆子替换
const beanImgReg = /\#bean\#/g
// 金币替换
const coinImgReg = /\#coin\#/g
// 啤酒替换
const beerImgReg = /\#beer\#/g

export default {
  props: {
    str: {
      type: String,
      default: ''
    },
    numsOption: {
      type: Array,
      default: () => {
        return [
          // {
          //   value: '',
          //   style: 'color: red'
          // }
        ]
      }
    },
    customClass: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    transform(str) {
      let packageType = ''

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        packageType = 'vava'
      }
      if (this.appNameFlag('echo', appName)) {
        packageType = 'echo'
      }
      if (this.appNameFlag('joychat', appName)) {
        packageType = 'joychat'
      }
      if (this.appNameFlag('kiko', appName)) {
        packageType = 'kiko'
      }
      if (this.appNameFlag('goparty', appName)) {
        packageType = 'goparty'
      }
      if (this.appNameFlag('joylink', appName)) {
        packageType = 'joylink'
      }

      const nums = str.match(tempReg)
      if (nums && nums.length) {
        nums.forEach((numStrItem) => {
          const index = numStrItem.match(/\d{1,}/)[0]
          const targetObj = this.numsOption[index]
          if (targetObj) {
            str = str.replace(`{n${index}}`, `<i style="${targetObj.style || ''}">${targetObj.value || ''}</i>`)
          }
        })
      }

      const beans = str.match(beanImgReg)
      if (beans && beans.length) {
        beans.forEach(() => {
          str = str.replace('#bean#', `<span class="unique-bean-icon ${packageType}-bean ${this.customClass.bean || ''}"></span>`)
        })
      }

      const coins = str.match(coinImgReg)
      if (coins && coins.length) {
        coins.forEach(() => {
          str = str.replace('#coin#', `<span class="unique-coin-icon ${packageType}-coin ${this.customClass.coin || ''}"></span>`)
        })
      }

      const beers = str.match(beerImgReg)
      if (beers && beers.length) {
        beers.forEach(() => {
          str = str.replace('#beer#', `<span class="unique-beer-icon ${packageType}-beer ${this.customClass.beer || ''}"></span>`)
        })
      }

      return str
    }
  }
}
</script>
<style lang="scss">
// bean
.unique-bean-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/beans.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.vava-bean {
  background-image: url('~@/assets/packageAssets/packages/vava/beans.png');
}

.echo-bean {
  background-image: url('~@/assets/packageAssets/packages/echo/beans.png');
}

.joychat-bean {
  background-image: url('~@/assets/packageAssets/packages/joychat/beans.png');
}

.kiko-bean {
  background-image: url('~@/assets/packageAssets/packages/kiko/beans.png');
}

.goparty-bean {
  // background-image: url('~@/assets/packageImage/goparty/beans.png');
}

.joylink-bean {
  // background-image: url('~@/assets/packageImage/joylink/beans.png');
}

// coin
.unique-coin-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  vertical-align: middle;

  background-image: url('~@/assets/packageAssets/packages/vava/coin.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.vava-coin {
  background-image: url('~@/assets/packageAssets/packages/vava/coin.png');
}

.echo-coin {
  background-image: url('~@/assets/packageAssets/packages/echo/coin.png');
}

.joychat-coin {
  background-image: url('~@/assets/packageAssets/packages/joychat/coin.png');
}

.goparty-coin {
  // background-image: url('~@/assets/packageImage/goparty/coin.png');
}

.joylink-coin {
  // background-image: url('~@/assets/packageImage/joylink/coin.png');
}

// beer
.unique-beer-icon {
  display: inline-block;
  width: 18px;
  height: 18px;

  background-image: url('~@/assets/packageAssets/common/beer.png');
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
}

.vava-beer {
  background-image: url('~@/assets/packageAssets/common/beer.png');
}

.echo-beer {
  background-image: url('~@/assets/packageAssets/common/beer.png');
}

.joychat-beer {
  background-image: url('~@/assets/packageAssets/common/beer.png');
}

.kiko-beer {
  background-image: url('~@/assets/packageAssets/common/beer.png');
}

.goparty-beer {
  // background-image: url('~@/assets/packageAssets/common/beer.png');
}

.joylink-beer {
  // background-image: url('~@/assets/packageAssets/common/beer.png');
}
</style>
